import { render } from "./ModalEdit.vue?vue&type=template&id=7b5d559e&scoped=true"
import script from "./ModalEdit.vue?vue&type=script&lang=js"
export * from "./ModalEdit.vue?vue&type=script&lang=js"

import "./ModalEdit.vue?vue&type=style&index=0&id=7b5d559e&scoped=true&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b5d559e"]])

export default __exports__